// libs
import React, { memo } from 'react';

// styles
import { Title, Text, Container, Pipe } from './styles';

//defs
interface PromotionTextProps {
  promotionTextConfig: {
    pipeColor?: string;
    textColor: string;
    text: string;
  };
  className?: string;
}

function PromotionText({ promotionTextConfig, className = '' }: PromotionTextProps) {
  return (
    <Container className={className}>
      {promotionTextConfig?.pipeColor && <Pipe color={promotionTextConfig.pipeColor} />}
      <Title>
        <Text color={promotionTextConfig?.textColor}>{promotionTextConfig?.text}</Text>
      </Title>
    </Container>
  );
}

export default memo(PromotionText);
